import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAIy8Tx0rnSDKxaO1WdxZplxsu5IcjEG-w",
  authDomain: "srpay-partner.firebaseapp.com",
  projectId: "srpay-partner",
  messagingSenderId: "459555230760",
  appId: "1:459555230760:web:7627a6d8d8321cfb52511d"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const messaging = firebase.messaging();

export const getFCMToken = async () => {
  try {
    const token = await messaging.getToken({
      vapidKey:
        "BACkfxrujgH1OyRP8vbQ5sf5oHG3RDi_yF2Jn4FgywU4Z0aXVWBt11xRdNDkGRUNmYTsj7GhtxAyoQVsXzY1TK0"
    });

    if (!token) {
      console.warn("⚠️ No registration token available");
    }

    return token;
  } catch (err) {
    console.error("❌ FCM token error:", err);
    return null;
  }
};


// ✅ ADD THIS EXPORT
export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export default firebase;
